import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { isFunction, merge } from 'lodash';
import { Popper } from 'react-popper';
import ResizeDetector from 'react-resize-detector';
import ClickOutside from "../../ClickOutside";
import Portal from "../../Portal";
import { checkPopoverArrowProp } from "../../../../utils/propTypes";

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      children = props.children,
      arrow = props.arrow,
      popper = props.popper,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      togglePopover = props.togglePopover,
      handleBodyClick = props.handleBodyClick,
      handleClickOutside = props.handleClickOutside,
      targetClickOutsideIgnoreClass = props.targetClickOutsideIgnoreClass,
      cover = props.cover;
  var popperProps = merge({
    modifiers: {
      offset: {
        offset: '0, 10'
      }
    }
  }, popper);
  var finalClassName = cx('nx-popover', {
    'nx-popover--cover': cover
  }, className);
  return React.createElement(Portal, null, React.createElement(ClickOutside, {
    outsideClickIgnoreClass: targetClickOutsideIgnoreClass,
    onClickOutside: handleClickOutside
  }, React.createElement(Popper, tslib_1.__assign({}, popperProps), function (_a) {
    var scheduleUpdate = _a.scheduleUpdate,
        popperProps = _a.popperProps,
        restProps = _a.restProps;
    return React.createElement("div", tslib_1.__assign({
      className: finalClassName,
      onClick: handleBodyClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, popperProps, restProps), isFunction(children) ? children({
      togglePopover: togglePopover
    }) : React.createElement("div", {
      className: "nx-popover__body"
    }, children), arrow && React.cloneElement(arrow, {
      className: cx('nx-popover__arrow', arrow.props.className),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }), React.createElement(ResizeDetector, {
      handleHeight: true,
      handleWidth: true,
      onResize: scheduleUpdate
    }));
  })));
};

PopoverBody.propTypes = {
  className: PropTypes.string,
  targetClickOutsideIgnoreClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  arrow: checkPopoverArrowProp.isRequired,
  // React-popper props
  popper: PropTypes.object,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  // popover actions
  togglePopover: PropTypes.func,
  handleBodyClick: PropTypes.func,
  handleClickOutside: PropTypes.func,
  cover: PropTypes.bool
};
export default PopoverBody;

try {
  // @ts-ignore
  PopoverBody.__docgenInfo = {
    "description": "",
    "displayName": "PopoverBody",
    "props": {
      "togglePopover": {
        "defaultValue": null,
        "description": "",
        "name": "togglePopover",
        "required": true,
        "type": {
          "name": "TogglePopoverType"
        }
      },
      "popper": {
        "defaultValue": null,
        "description": "",
        "name": "popper",
        "required": true,
        "type": {
          "name": "IPopperProps"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "onMouseEnter": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseEnter",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onMouseLeave": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseLeave",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "handleBodyClick": {
        "defaultValue": null,
        "description": "",
        "name": "handleBodyClick",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "handleClickOutside": {
        "defaultValue": null,
        "description": "",
        "name": "handleClickOutside",
        "required": true,
        "type": {
          "name": "(event: MouseEvent<Element>) => void"
        }
      },
      "targetClickOutsideIgnoreClass": {
        "defaultValue": null,
        "description": "",
        "name": "targetClickOutsideIgnoreClass",
        "required": true,
        "type": {
          "name": "string | undefined"
        }
      },
      "arrow": {
        "defaultValue": null,
        "description": "",
        "name": "arrow",
        "required": false,
        "type": {
          "name": "false | ReactElement<ArrowProps> | undefined"
        }
      },
      "cover": {
        "defaultValue": null,
        "description": "",
        "name": "cover",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}